import React from "react";
import {connect} from "react-redux";
import {Navigate} from "react-router-dom";

import AgrismartDashboard from "../Agrismart/AgrismartDashboard";
import Agrismart2Dashboard from "../Agrismart/Agrismart2Dashboard";
import BadgeDashboard from "../Badge/BadgeDashboard";
import TrackerDashboard from "../Tracker/TrackerDashboardContainer";
import SolarsmartDashboard from "../Solarsmart/SolarsmartDashboard";
import SwitchDashboard from "../Switch/SwitchDashboard";
import RadarpestDashboard from "./RadarpestDashboard";

import {projects as projectsConstants} from "../../constants";

const mapStateToProps = ({session}) => ({
	project: session.project
});

const mapDispatchToProps = {
};

class DashboardDispatcher extends React.Component {

	render() {
		if (!this.props.project) return <Navigate to="/" />
		switch (this.props.project.projectTypeName) {
			case projectsConstants.names.AGRISMART: return <AgrismartDashboard/>;
			case projectsConstants.names.AGRISMART2: return <Agrismart2Dashboard/>;
			case projectsConstants.names.AGRIVOLTAICO: return <AgrismartDashboard/>;
			case projectsConstants.names.ALARM: return <TrackerDashboard/>;
			case projectsConstants.names.BADGE: return <BadgeDashboard/>;
			case projectsConstants.names.METEOSMART: return <AgrismartDashboard/>;
			case projectsConstants.names.SOLARSMART: return <SolarsmartDashboard/>;
			case projectsConstants.names.SWITCH: return <SwitchDashboard/>;
			case projectsConstants.names.RADARPEST: return <RadarpestDashboard/>;
			case projectsConstants.names.TRACKER: return <TrackerDashboard/>;
			case projectsConstants.names.TRAPSCORE: return <RadarpestDashboard/>;
			default: return <Navigate to="/404" />
		}
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardDispatcher);
